import React, { useEffect, useRef, useState } from "react";
import { getApi } from "../../services/api/globalApi";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import Pagination from "../../components/common/pagination/Pagination";
import Button from "../../components/common/button/Button";
import OrderCard from "./sub-components/order-card/OrderCard";

function OrderList() {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const latestRequest = useRef(0);

  const { utils } = useSelector(utilsState);

  const getOrders = async (params) => {
    const path = "admin/orders";
    const requestId = ++latestRequest.current;
    setLoading(true);
    setError(false);
    try {
      const response = await getApi({
        path,
        params: { ...params, limit: 20 },
      });
      if (requestId !== latestRequest.current) return;
      setData(response.data.result.data || []);
      setPagination(response.data.result);
    } catch (error) {
      if (requestId === latestRequest.current) setError(true);
    } finally {
      if (requestId === latestRequest.current) setLoading(false);
    }
  };

  useEffect(() => {
    if (utils) {
      filterDataHandler({
        proccessShipping:
          utils?.ORDER_PROCCESS_SHIPPING_STATUS?.awaitingAccepted?.value,
        paymentStatus: utils?.PAYMENT_STATUS?.done?.value,
        sort: "-paymentDate",
      });
    }
  }, [utils]);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getOrders(allFilter);
  };

  const navigate = useNavigate();

  const getOrderInfo = (id) => {
    navigate(`/order-list/${id}`);
  };
  const handlePrint = () => {
    navigate("/multi-print", { state: { printData: data } });
  };

  return (
    <div className="rounded-3xl bg-white p-4 shadow-sm sm:p-6 dark:bg-gray-900">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h3 className="text-xl font-bold text-slate-900 dark:text-white">لیست سفارش‌ها</h3>
          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">وضعیت پرداخت و ارسال را بررسی و سفارش‌ها را مدیریت کنید.</p>
        </div>
        {!!data.length && <Button
          onClick={handlePrint}
          text={"پرینت این صفحه"}
          type="button"
          color="success"
          className="!w-auto"
        />}
      </div>
      <div className="mt-5 rounded-2xl border border-slate-200 bg-slate-50/70 dark:border-slate-700 dark:bg-slate-800/50">
        <div className="px-2 flex flex-col md:flex-row items-center justify-between">
          <div className="admin-filter-grid py-4">
            <select
              value={filter?.paymentStatus ?? ""}
              onChange={(e) =>
                filterDataHandler({ page: 1, paymentStatus: e.target.value })
              }
              className="backdrop-blur block w-full sm:w-auto p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50/50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700/70 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option value="">همه وضعیت‌های پرداخت</option>
              {utils &&
                utils?.PAYMENT_STATUS_VALUES.map((item) => <option key={item.value} value={item.value}>{item.name}</option>)}
            </select>
            <select
              value={filter?.proccessShipping ?? ""}
              onChange={(e) =>
                filterDataHandler({ page: 1, proccessShipping: e.target.value })
              }
              className="backdrop-blur block w-full sm:w-auto p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50/50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700/70 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option value="">همه وضعیت‌های مرسوله</option>
              {utils &&
                utils?.ORDER_PROCCESS_SHIPPING_STATUS_VALUES.map((item) => <option key={item.value} value={item.value}>{item.name}</option>)}
            </select>
            <select
              value={filter?.sort ?? ""}
              onChange={(e) =>
                filterDataHandler({ page: 1, sort: e.target.value })
              }
              className="backdrop-blur block w-full sm:w-auto p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50/50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700/70 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option value={""}>{"بدون مرتب سازی"}</option>
              <option value={"-paymentDate"}>
                {"جدیدترین پرداختی"}
              </option>
              <option value={"paymentDate"}>{"قدیمی ترین پرداختی"}</option>
              <option value={"-createdAt"}>{"جدیدترین"}</option>
              <option value={"-trackingCode"}>{"شماره سفارش نزولی"}</option>
              <option value={"trackingCode"}>{"شماره سفارش صعودی"}</option>
              <option value={"createdAt"}>{"قدیمی ترین"}</option>
            </select>
            <div className="w-full min-w-0">
              <div className="relative w-full">
                <div className="absolute z-[1] inset-y-0 left-0 flex items-center px-3 pointer-events-none">
                  <svg
                    className="w-5 h-5 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </div>
                <input
                  type="text"
                  id="table-search"
                  className="block p-2 pe-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-full bg-white/50 backdrop-blur-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="جست و جو ..."
                  value={filter?.searchText ?? ""}
                  onChange={(e) =>
                    filterDataHandler({ page: 1, searchText: e.target.value })
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div data-list-start className="mt-5 flex flex-wrap items-center justify-between gap-2 text-sm text-slate-500 dark:text-slate-400">
        <span>{loading ? "در حال دریافت سفارش‌ها..." : error ? "دریافت سفارش‌ها ناموفق بود" : `${pagination?.totalDocs ?? data.length} سفارش`}</span>
        {pagination?.totalPages > 1 && <span>صفحه {pagination.page} از {pagination.totalPages}</span>}
      </div>
      {error && (
        <div role="alert" className="mt-4 flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-rose-200 bg-rose-50 p-5 text-sm text-rose-800 dark:border-rose-900 dark:bg-rose-900/20 dark:text-rose-200">
          <span>دریافت سفارش‌ها انجام نشد. اتصال را بررسی کنید و دوباره تلاش کنید.</span>
          <button type="button" onClick={() => getOrders(filter || {})} className="rounded-lg bg-rose-700 px-3 py-2 text-white hover:bg-rose-800">تلاش مجدد</button>
        </div>
      )}
      {loading && !data.length && (
        <div role="status" className="mt-4 space-y-3" aria-label="در حال دریافت سفارش‌ها">
          {[0, 1, 2].map((item) => <div key={item} className="h-40 animate-pulse rounded-2xl border border-slate-100 bg-slate-100 dark:border-slate-700 dark:bg-slate-800" />)}
        </div>
      )}
      {!loading && !error && !data.length && (
        <div className="mt-4 rounded-2xl border border-dashed border-slate-300 p-10 text-center text-sm text-slate-500 dark:border-slate-700 dark:text-slate-400">سفارشی با این فیلترها پیدا نشد.</div>
      )}
      {!!data.length && !error && (
        <div className={`mt-4 w-full space-y-4 ${loading ? "opacity-60" : ""}`} aria-busy={loading}>
          {data.map((item, index) => {
            return (
              <OrderCard
                reGetData={() => getOrders(filter || {})}
                utils={utils}
                key={item._id || index}
                data={item}
                getOrderInfo={getOrderInfo}
              />
            );
          })}
        </div>
      )}
      {!loading && !error && <div className="mt-5">
        <Pagination
          filterDataHandler={filterDataHandler}
          pagination={pagination}
        />
      </div>}
    </div>
  );
}

export default OrderList;
